// components/StartDivorceForm.tsx
import React, { useState } from "react";
import { Subheading } from "../../../design/heading";

const OnboardingContainer: React.FC<{
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
}> = ({ title, subtitle, children }) => {
  return (
    <div>
      <div className="w-full p-8 bg-white rounded-lg shadow-lg">
        <h1 className="mb-2 text-4xl font-bold text-black">{title}</h1>
        {subtitle && <Subheading>{subtitle}</Subheading>}
        <div className="mt-6">{children}</div>
      </div>
    </div>
  );
};

export default OnboardingContainer;
